var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasePopup',{ref:"basePopup",class:[
        'popup-confirmation',
        {'popup-confirmation--default-styles': _vm.defaultStylesForContent}
    ],attrs:{"title":_vm.title,"text-action-success":_vm.confirmText,"text-action-cancel":_vm.cancelText,"hide-cancel-action":_vm.hideCancelAction,"hide-success-action":_vm.hideConfirmAction,"validation-passed":!_vm.confirmBtnDisabled},on:{"success":_vm.confirm,"close":_vm.emitClose}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }